import { Component, HostBinding, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Models } from '../date/DataTypes';

@Component({
  selector: 'CalendarWeekPanel, nzm-calendar-week-panel',
  templateUrl: './week-panel.component.html',
  encapsulation: ViewEncapsulation.None
})
export class WeekPanelComponent implements OnInit {
  constructor() {}

  week: string[] = ['æ¥', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'];

  private _locale: Models.Locale;

  @Input()
  set locale(value) {
    this._locale = value;
  }

  @HostBinding('class.week-panel') weekPanel: boolean = true;

  ngOnInit() {
    this.week = this._locale.week;
  }
}
